import { render, staticRenderFns } from "./ConfigBar.vue?vue&type=template&id=2b9cd3ce&"
import script from "./ConfigBar.vue?vue&type=script&lang=js&"
export * from "./ConfigBar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConfigBar.vue"
export default component.exports